import {Component, OnInit, Input, ViewChild, OnDestroy, AfterViewInit} from '@angular/core';
import {Project} from '../../../data/project/project';
import {ProjectService} from '../../../data/project/project.service';
import {NgForm} from '@angular/forms';
import {distinctUntilChanged, debounceTime, filter, takeUntil, skip} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {WsService} from '../../../../data/ws.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {WsUpdateResponce} from '../../../../data/ws-update-responce';
import {Subject, Subscription, timer} from 'rxjs';
import {CustomerService} from '../../../../customer/data/customer.service';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {ProjectTypeEditComponent} from '../../project-type-edit/project-type-edit.component';

@Component({
  selector: 'app-project-info-block',
  templateUrl: './project-info-block.component.html',
  styleUrls: ['./project-info-block.component.scss']
})
@RxJSUnsubscribe
export class ProjectInfoBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  project: Project

  @ViewChild('projectForm', {static: true})
  projectForm: NgForm;

  @ViewChild('projectTypeDropdown', {static: false})
  projectTypeDropdown: ProjectTypeEditComponent;

  copyLabel = 'Copy';

  navigatorHasShare = !!navigator.share;

  locationInputText = ''

  wsSub: Subscription;

  constructor(
    protected customerService: CustomerService,
    protected projectService: ProjectService,
    protected dialog: MatDialog,
    protected appStateQuery: AppStateQuery,
    protected wsService: WsService
  ) {
  }

  ngOnInit() {
    this.initRealTimeUpdate();

    this.projectForm.valueChanges
      .pipe(
        skip(2),
        debounceTime(1000),
        distinctUntilChanged(),
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(value => {
        this.changeInfoMethod(value)
      })

  }

  initRealTimeUpdate() {
    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
      .pipe(
        filter(updateInfo => updateInfo.entity.id === this.project.id),
        // debounceTime(1000)
      )
      .subscribe(updateInfo => {
        const activeTagName = document.activeElement.tagName.toLowerCase();
        if (updateInfo.action === 'UPDATE') {
          // tslint:disable-next-line: forin
          for (const prop in updateInfo.entity) {

            if (!(activeTagName === 'textarea' || activeTagName === 'input') || document.activeElement.getAttribute('name') !== prop) {
              if (prop === 'customer') {
                if (updateInfo.entity.customer) {
                  this.customerService.getCustomer(updateInfo.entity.customer.id).subscribe(customer => this.project.customer = customer)
                }
              } else if (prop === 'type') {
                this.projectService.getProjectTypes().subscribe(statuses => {
                  this.project[prop] = statuses.find(status => status.id === updateInfo.entity.type.id)
                });
              } else if (prop === 'jobComplexity') {
                this.projectService.getComplexities().subscribe(statuses => {
                  this.project[prop] = statuses.find(status => status.id === updateInfo.entity.jobComplexity.id)
                });
              } else if (prop === 'paymentStatus') {
                this.projectService.getPaymentStatuses().subscribe(statuses => {
                  this.project[prop] = statuses.find(status => status.id === updateInfo.entity.paymentStatus.id)
                });
              } else if (prop === 'name' || prop === 'location') {

              } else {
                this.project[prop] = updateInfo.entity[prop];
              }
            }
          }
        }
        if (updateInfo.action === 'DELETE') {
          console.log('Deleted!')
        }
      })

  }

  changeInfoMethod(value: Project) {
    this.projectService
      .saveProject({
        id: this.project.id,
        name: value.name,
        location: value.location,
        finishingVendor: value.finishingVendor
      })
      .subscribe(() => {
      })
  }

  openMap() {
    if ((navigator.platform.indexOf('iPhone') !== -1)
      || (navigator.platform.indexOf('iPod') !== -1)
      || (navigator.platform.indexOf('iPad') !== -1)) {

      window.open(`maps://maps.google.com/?q=${this.project.location}`);
    } else {
      window.open(`http://maps.google.com/?q=${this.project.location}`);
    }
  }

  shareLocation() {
    if (!navigator.share) {
      return
    }
    navigator.share({
      title: `Job Location`,
      text: `${this.project.name}:
			${this.project.location}`,
    })
      .then(() => {
      })
      .catch(() => {
      })
  }

  copyLink(inputElement) {

    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);

    this.copyLabel = 'Copied!'

    timer(5000).subscribe(() => {
      this.copyLabel = 'Copy'
    })
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
